import { LineLoading } from "@/components/loading";
import DashboardLayout from "@/layouts/dashboard";
import AuthGuard from "@/routes/components/auth-guard";
import { Suspense, lazy } from "react";
import type { RouteObject } from "react-router";
import { Navigate } from "react-router";

const { VITE_APP_HOMEPAGE: HOMEPAGE } = import.meta.env;

// dashboard

// custom components

// error
const Page403 = lazy(() => import("@/pages/sys/error/Page403"));
const Page404 = lazy(() => import("@/pages/sys/error/Page404"));
const Page500 = lazy(() => import("@/pages/sys/error/Page500"));

// tenant
const TenantListPage = lazy(() => import("@/pages/tenant"));

// version
const ConsoleVersion = lazy(() => import("@/pages/version/ConsoleVersion"));
const BotVersion = lazy(() => import('@/pages/version/BotVersion'));

// instance
const ConsoleInstance = lazy(() => import("@/pages/instance/ConsoleInstance"));
const BotInstance = lazy(() => import("@/pages/instance/BotInstance"));

// support case
const SupportCase = lazy(() => import("@/pages/supportCase"));

// parameter schema
const ParameterSchema = lazy(() => import("@/pages/ParameterSchema"));
const Templates = lazy(() => import("@/pages/ParameterSchema/Templates"));

const BotState = lazy(() => import('@/pages/BotState'))

const BotVolume = lazy(() => import('@/pages/botVolume/BotVolume'))

// others

// menu level

export const dashboardRoutes: RouteObject[] = [
	{
		path: "/",
		element: (
			<AuthGuard>
				<Suspense fallback={<LineLoading />}>
					{/* outlet inside DashboardLayout */}
					<DashboardLayout />
				</Suspense>
			</AuthGuard>
		),
		children: [
			{ index: true, element: <Navigate to={HOMEPAGE} replace /> },
			{ path: 'tenant', element: <TenantListPage /> },
			{ path: 'console-version', element: <ConsoleVersion /> },
			{ path: 'bot-version', element: <BotVersion /> },
			{ path: 'console-instance', element: <ConsoleInstance /> },
			{ path: 'bot-instance', element: <BotInstance /> },
			{ path: 'parameter-schema', element: <ParameterSchema /> },
			{ path: 'parameter-schema/:id', element: <Templates /> },
			{ path: 'support-case', element: <SupportCase /> },
			{ path: 'bot-state', element: <BotState /> },
			{ path: 'bot-volume', element: <BotVolume /> },
			{
				path: "error",
				children: [
					{ index: true, element: <Navigate to="403" replace /> },
					{ path: "403", element: <Page403 /> },
					{ path: "404", element: <Page404 /> },
					{ path: "500", element: <Page500 /> },
				],
			},
		],
	},
];
